import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import UserContext from '../../utils/user-context';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import { FragmentNames, MyChartMedicineInactivateAliases } from '../../codegen';
import { ContextType, SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component/context';
import { InputAPI } from '@philips-internal/oswald-ui-components';

@Controller({ fragment: FragmentNames.MY_CHART_MEDICINE_INACTIVATE })
class MyChartMedicineInactivateController extends BaseController {

  @Inject(ContextType.SUBMITTABLE_FRAGMENT)
    submittableFragmentContext!: SubmittableFragmentContext;

  @Inject(MyChartMedicineInactivateAliases.INPUT_INACTIVATE)
    inactivateFieldNotesApi!: InputAPI;

  @OnClick({ target: MyChartMedicineInactivateAliases.BUTTON_CANCEL })
  handleBtnCancel(): void {
    this.submittableFragmentContext.cancel(new SubmitEvent());
  }

  @OnClick({ target: MyChartMedicineInactivateAliases.BUTTON_INACTIVATE })
  handleBtnSendNewMedicine(): void {
    const medicineSequence = this.historyService.getCurrentRouteParams().medicineSequence as string;
    const justification = this.inactivateFieldNotesApi.getValue();

    let  body = this.addValueToBodyFilter('justification', justification.toString() , {});
    body = this.addValueToBodyFilter('id', medicineSequence.toString() , body);

    this.context.set({
      params: {
        ...body
      }
    });
    HttpService.post(APPLICATION_ENDPOINTS.POST_MC_MEDICINE_INACTIVATE, {  patientId: UserContext.patientId }, { body })
      .then(() => {
        this.submittableFragmentContext.submit(new SubmitEvent());
      });
  }

  private addValueToBodyFilter(field: string, value: string | undefined | string[], body: Record<string, Value>): Record<string, Value> {
    if (value) {
      return { ...body, [field]: value };
    }
    return body;
  }
}
export default MyChartMedicineInactivateController;
